import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import VueI18n from 'vue-i18n'

Vue.use(VideoPlayer)
Vue.use(ElementUI);
Vue.use(VueI18n)

Vue.config.productionTip = false

Vue.prototype.fullscreenLoading = function () {
    return this.$loading({lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
}
//中英文配置
const i18n = new VueI18n({
    locale: 'en',
    messages: {
        en: {
            contact_name: 'Name',
            contact_phone: 'Phone',
            contact_email: 'Email',
            contact_service: 'Service',
            contact_message: 'Message',
            contact_cancel: 'Cancel',
            contact_submit: 'Submit',
            contact_services: [{title: 'Software Development',}, {title: 'Data Processing ',}, {title: '3D Modeling',}],

            companyName: 'KINGWIN',
            navItems: [
                {id: '/', title: 'Home'},
                {id: '/services', title: 'Services'},
                {id: '/showcase', title: 'Showcase'},
                {id: '/about', title: 'About'},
            ],

            head_touch_button: 'Get in Touch',
            head_language_button: 'Switch to Chinese',

            foot_about: 'KingWin Digital is a leading technology solutions provider dedicated to helping clients achieve business transformation and growth through innovative technology.',
            foot_title_about: 'About Us',
            foot_title_contact: 'Contact Us',
            foot_title_quick: 'Quick Links',
            foot_address: 'No. 199 Chongwen Road, Suzhou Industrial Park, Suzhou City, Jiangsu Province',

            hero_company: 'KingWin Digital Service Co.,Ltd',
            hero_description: 'Providing cutting-edge data services, 3D visual technology, and software development to facilitate enterprises digital transformation',
            hero_button: 'Learn More',

            profile_title: 'Company Profile',
            profile_deputy_title: 'Get to know our professional and responsible company',
            profile_content_title: 'InnovateTech, Leading the Future',
            profile_content_1: 'KingWin Digital was founded in 2019, starting as a small startup and growing into an industry-leading technology solutions provider. Our journey began with a simple idea: to make the world better through technology.',
            profile_content_2: 'Over the years, we have collaborated with clients across various industries, providing customized solutions to help them address complex business challenges and achieve digital transformation.',
            profile_content_3: 'Our team consists of experienced engineers, designers, and industry experts who are passionate about solving complex problems and creating impactful solutions.',

            team_title: 'Team Profile',
            team_deputy_title: 'Get to know our professional and creative team members',
            teamMembers: [
                {
                    id: 1,
                    name: 'Zhang Ming',
                    position: 'Technical Director',
                    description: '15 years of software development experience, focusing on enterprise level application architecture design',
                    avatar: require('@/assets/teamMember_1.jpg')
                },
                {
                    id: 2,
                    name: 'Li Xue',
                    position: 'Design Director',
                    description: '10 years of experience in 3D modeling and visualization, skilled in modeling complex scenes',
                    avatar: require('@/assets/teamMember_2.jpg')
                },
                {
                    id: 3,
                    name: 'Wang Lin',
                    position: 'Project Manager',
                    description: '12 years of project management experience, proficient in agile development methodology',
                    avatar: require('@/assets/teamMember_3.jpg')
                },
                {
                    id: 4,
                    name: 'Zhao Lin',
                    position: 'Senior Engineer',
                    description: 'Full stack development expert, skilled in integrating front-end and back-end technologies',
                    avatar: require('@/assets/teamMember_4.jpg')
                }
            ],

            data_title: 'Data achievements',
            data_deputy_title: 'Speak with data, showcase our professional capabilities and industry influence',
            dataStats: [
                {
                    id: 1,
                    icon: 'fa fa-cubes',
                    value: '200+',
                    label: 'Successfully delivered the project'
                },
                {
                    id: 2,
                    icon: 'fa fa-industry',
                    value: '15+',
                    label: 'Service industry field'
                },
                {
                    id: 3,
                    icon: 'fa fa-line-chart',
                    value: '45%',
                    label: 'Annual average business growth'
                },
                {
                    id: 4,
                    icon: 'fa fa-smile-o',
                    value: '98%',
                    label: 'Customer satisfaction'
                },
                {
                    id: 5,
                    icon: 'fa fa-users',
                    value: '50+',
                    label: 'Professional team members'
                },
                {
                    id: 6,
                    icon: 'fa fa-globe',
                    value: '5',
                    label: 'Serving countries and regions'
                }
            ],

            service_title: 'Our Services',
            service_deputy_title: 'our professional technical team is here to provide you with comprehensive technological solutions',
            services: [
                {
                    'id': 1,
                    'i': 'fa fa-database',
                    'h': 'Software Development',
                    'p': 'provide comprehensive data solutions, from collection to analysis, to help enterprises unlock the value of data',
                    'li': [
                        'Data cleaning, Data fine-tuning',
                        'Data organization',
                        'Data pretraining',
                        'Annotation'
                    ]
                },
                {
                    'id': 2,
                    'i': 'fa fa-cube',
                    'h': 'Data Service',
                    'p': 'professional 3D modeling and rendering services provide a realistic visual display for your products',
                    'li': [
                        '3D modeling, Rendering, Animation',
                        'special effects, Artwork',
                        'Cartoon promotional page design',
                        'Logo design, UI design'
                    ]
                },
                {
                    'id': 3,
                    'i': 'fa fa-code ',
                    'h': '3D vision technology',
                    'p': 'customized software development services to cater to various business scenarios of enterprises',
                    'li': [
                        'JAVA software development',
                        'Python development',
                        'Agent development, Crawler development',
                        'APP development, Front-end development'
                    ]
                },
            ],

            reason_title: 'Reason for selection',
            reason_deputy_title: 'With advanced technology and rich experience, we provide customers with excellent solutions',
            reason_h: 'Why choose KingWin Digital？',
            reason_p: 'We not only provide technical solutions, but more importantly, we understand your business needs and can combine technology with business goals to create real business value.',
            reason_expertiseList: [
                {id: 1, text: 'A technical team with over 10 years of industry experience'},
                {id: 2, text: 'Adopting the latest development tools and technology stack'},
                {id: 3, text: 'Strict quality control and testing processes'},
                {id: 4, text: 'A comprehensive after-sales support and service system'},
                {id: 5, text: 'Flexible delivery mode and project management'},
                {id: 6, text: 'Protecting customer intellectual property and data security'}
            ],
            reason_stats: [
                {id: 1, number: 200, label: 'Successful Projects'},
                {id: 2, number: 50, label: 'Industrial customers'},
                {id: 3, number: 10, label: 'Years of experience'},
                {id: 4, number: 98, label: 'Customer satisfaction'}
            ],

            case_title: 'Success Cases',
            case_deputy_title: 'explore the innovative solutions we offer to clients in various industries',
            cases: [
                {
                    id: 1,
                    title: 'Intelligent Manufacturing Management System',
                    description: 'The intelligent production management system developed for large manufacturing enterprises has achieved digitalization and automation of the production process.',
                    image: require('@/assets/case_1.avif'),
                    tags: ['Enterprise software', 'Smart Manufacturing', 'ERP system'],
                    category: 'software',
                    selectedCase: {
                        title: 'Intelligent Manufacturing Factory Digital Transformation Project',
                        description: 'To create intelligent production systems for large manufacturing enterprises, achieving comprehensive digitalization and automation management of production processes.',
                        category: 'Smart Manufacturing',
                        date: '2023-03-15',
                        duration: '8 months',
                        scale: 'large-scale project',
                        background: 'The manufacturing enterprise is facing problems such as low production efficiency, difficulty in quality control, and low equipment utilization. I hope to achieve intelligent management of the production process and improve overall operational efficiency through digital transformation.',
                        solution: 'We provide intelligent manufacturing solutions based on industrial Internet of Things and AI technology, including functional modules such as device interconnection, real-time collection and analysis of production data, intelligent scheduling, and quality prediction. Through the combination of edge computing and cloud computing, the digital management of the whole production process is realized.',
                        testimonial: 'Jingyun Technologys solution has helped us achieve comprehensive digitization of the production process, increasing production efficiency by 35% and significantly improving product quality stability. The collaborative team is professional and efficient, and project delivery exceeds expectations.',
                        partners: [
                            {
                                id: 1,
                                name: 'Huawei Cloud (a research and operation organization under Huawei Technologies Co., Ltd.)',
                                role: 'Cloud platform provider'
                            },
                            {id: 2, name: 'Siemens (China) Co., Ltd', role: 'Industrial Automation Partner'},
                            {
                                id: 3,
                                name: 'Zhongke Shuguang (Shuguang Information Industry Co., Ltd.)',
                                role: 'Hardware equipment suppliers'
                            }
                        ],
                        video_url: require('@/assets/3d_2.mp4')
                    }
                },
                {
                    id: 2,
                    title: '3D visualization of construction projects',
                    description: 'High precision building models and interactive visualization systems created for real estate developers to assist in project marketing.',
                    image: require('@/assets/case_2.jpg'),
                    tags: ['3D modeling', 'visualization', 'VR display'],
                    category: 'modeling',
                    selectedCase: {
                        title: 'Smart Financial Risk Control Platform',
                        description: 'Build AI based intelligent risk control systems for financial institutions to improve credit approval efficiency and risk identification capabilities.',
                        category: 'FinTech',
                        date: '2022-11-20',
                        duration: '6 months',
                        scale: 'medium-sized project',
                        background: 'Financial institutions face problems such as low efficiency of manual review and inaccurate risk identification in the credit approval process. We need to build an intelligent risk control system to improve approval efficiency and accuracy.',
                        solution: 'We have developed an intelligent risk control platform based on machine learning and deep learning, integrating multiple sources of data and constructing user credit rating models and fraud detection models. The system can analyze user behavior data in real-time and automatically identify potential risks.',
                        testimonial: 'The risk control platform of Jingyun Technology has greatly improved our credit approval efficiency, reducing the approval time from 3 days to 2 hours, and increasing the accuracy of risk identification by 40%.',
                        partners: [
                            {id: 1, name: 'Tencent Cloud', role: 'Cloud computing service provider'},
                            {id: 2, name: 'Ant Group', role: 'Data Service Partners'},
                            {id: 3, name: 'Ping An Technology', role: 'Financial Technology Advisor'}
                        ],
                        video_url: require('@/assets/3d_1.mp4')
                    }
                },
                {
                    id: 3,
                    title: 'Big data analysis platform',
                    description: 'A real-time data analysis and visualization platform developed for financial institutions, providing in-depth business insights.',
                    image: require('@/assets/case_3.avif'),
                    tags: ['data analysis', 'data cleaning'],
                    category: 'software',
                    selectedCase: {
                        title: 'Intelligent Manufacturing Factory Digital Transformation Project',
                        description: 'To create intelligent production systems for large manufacturing enterprises, achieving comprehensive digitalization and automation management of production processes.',
                        category: 'Smart Manufacturing',
                        date: '2023-03-15',
                        duration: '8 months',
                        scale: 'large-scale project',
                        background: 'The manufacturing enterprise is facing problems such as low production efficiency, difficulty in quality control, and low equipment utilization. I hope to achieve intelligent management of the production process and improve overall operational efficiency through digital transformation.',
                        solution: 'We provide intelligent manufacturing solutions based on industrial Internet of Things and AI technology, including functional modules such as device interconnection, real-time collection and analysis of production data, intelligent scheduling, and quality prediction. Through the combination of edge computing and cloud computing, the digital management of the whole production process is realized.',
                        testimonial: 'Jingyun Technologys solution has helped us achieve comprehensive digitization of the production process, increasing production efficiency by 35% and significantly improving product quality stability. The collaborative team is professional and efficient, and project delivery exceeds expectations.',
                        partners: [
                            {
                                id: 1,
                                name: 'Huawei Cloud (a research and operation organization under Huawei Technologies Co., Ltd.)',
                                role: 'Cloud platform provider'
                            },
                            {id: 2, name: 'Siemens (China) Co., Ltd', role: 'Industrial Automation Partner'},
                            {
                                id: 3,
                                name: 'Zhongke Shuguang (Shuguang Information Industry Co., Ltd.)',
                                role: 'Hardware equipment suppliers'
                            }
                        ],
                        video_url: require('@/assets/3d_2.mp4')
                    }
                },
                {
                    id: 4,
                    title: 'Industrial Product Design and Simulation',
                    description: 'Provide 3D modeling and physical simulation solutions for manufacturing enterprises to optimize the product design process.',
                    image: require('@/assets/case_4.avif'),
                    tags: ['product design', 'physical simulation', 'industrial design'],
                    category: 'modeling',
                    selectedCase: {
                        title: 'Smart Financial Risk Control Platform',
                        description: 'Build AI based intelligent risk control systems for financial institutions to improve credit approval efficiency and risk identification capabilities.',
                        category: 'FinTech',
                        date: '2022-11-20',
                        duration: '6 months',
                        scale: 'medium-sized project',
                        background: 'Financial institutions face problems such as low efficiency of manual review and inaccurate risk identification in the credit approval process. We need to build an intelligent risk control system to improve approval efficiency and accuracy.',
                        solution: 'We have developed an intelligent risk control platform based on machine learning and deep learning, integrating multiple sources of data and constructing user credit rating models and fraud detection models. The system can analyze user behavior data in real-time and automatically identify potential risks.',
                        testimonial: 'The risk control platform of Jingyun Technology has greatly improved our credit approval efficiency, reducing the approval time from 3 days to 2 hours, and increasing the accuracy of risk identification by 40%.',
                        partners: [
                            {id: 1, name: 'Tencent Cloud', role: 'Cloud computing service provider'},
                            {id: 2, name: 'Ant Group', role: 'Data Service Partners'},
                            {id: 3, name: 'Ping An Technology', role: 'Financial Technology Advisor'}
                        ],
                        video_url: require('@/assets/3d_1.mp4')
                    }
                },
                {
                    id: 5,
                    title: 'Medical and health mobile applications',
                    description: 'A mobile health management platform developed for medical institutions, providing patient management and remote medical services.',
                    image: require('@/assets/case_5.avif'),
                    tags: ['mobile application', 'iOS/Android'],
                    category: 'software',
                    selectedCase: {
                        title: 'Intelligent Manufacturing Factory Digital Transformation Project',
                        description: 'To create intelligent production systems for large manufacturing enterprises, achieving comprehensive digitalization and automation management of production processes.',
                        category: 'Smart Manufacturing',
                        date: '2023-03-15',
                        duration: '8 months',
                        scale: 'large-scale project',
                        background: 'The manufacturing enterprise is facing problems such as low production efficiency, difficulty in quality control, and low equipment utilization. I hope to achieve intelligent management of the production process and improve overall operational efficiency through digital transformation.',
                        solution: 'We provide intelligent manufacturing solutions based on industrial Internet of Things and AI technology, including functional modules such as device interconnection, real-time collection and analysis of production data, intelligent scheduling, and quality prediction. Through the combination of edge computing and cloud computing, the digital management of the whole production process is realized.',
                        testimonial: 'Jingyun Technologys solution has helped us achieve comprehensive digitization of the production process, increasing production efficiency by 35% and significantly improving product quality stability. The collaborative team is professional and efficient, and project delivery exceeds expectations.',
                        partners: [
                            {
                                id: 1,
                                name: 'Huawei Cloud (a research and operation organization under Huawei Technologies Co., Ltd.)',
                                role: 'Cloud platform provider'
                            },
                            {id: 2, name: 'Siemens (China) Co., Ltd', role: 'Industrial Automation Partner'},
                            {
                                id: 3,
                                name: 'Zhongke Shuguang (Shuguang Information Industry Co., Ltd.)',
                                role: 'Hardware equipment suppliers'
                            }
                        ],
                        video_url: require('@/assets/3d_2.mp4')
                    }
                },
                {
                    id: 6,
                    title: 'Virtual Reality Training System',
                    description: 'A VR safety training system developed for energy companies, providing an immersive operational training experience.',
                    image: require('@/assets/case_6.avif'),
                    tags: ['VR/AR', 'training system', '3D interaction'],
                    category: 'modeling',
                    selectedCase: {
                        title: 'Smart Financial Risk Control Platform',
                        description: 'Build AI based intelligent risk control systems for financial institutions to improve credit approval efficiency and risk identification capabilities.',
                        category: 'FinTech',
                        date: '2022-11-20',
                        duration: '6 months',
                        scale: 'medium-sized project',
                        background: 'Financial institutions face problems such as low efficiency of manual review and inaccurate risk identification in the credit approval process. We need to build an intelligent risk control system to improve approval efficiency and accuracy.',
                        solution: 'We have developed an intelligent risk control platform based on machine learning and deep learning, integrating multiple sources of data and constructing user credit rating models and fraud detection models. The system can analyze user behavior data in real-time and automatically identify potential risks.',
                        testimonial: 'The risk control platform of Jingyun Technology has greatly improved our credit approval efficiency, reducing the approval time from 3 days to 2 hours, and increasing the accuracy of risk identification by 40%.',
                        partners: [
                            {id: 1, name: 'Tencent Cloud', role: 'Cloud computing service provider'},
                            {id: 2, name: 'Ant Group', role: 'Data Service Partners'},
                            {id: 3, name: 'Ping An Technology', role: 'Financial Technology Advisor'}
                        ],
                        video_url: require('@/assets/3d_1.mp4')
                    }
                }
            ],

            expertise_title: 'Technical Advantage',
            expertise_deputy_title: 'With advanced technology and rich experience, we provide customers with excellent solutions',
            expertises: [
                {
                    id: 1,
                    icon: 'fa fa-code',
                    title: 'Customized software development',
                    description: 'Develop customized software solutions with complete functionality and superior performance based on customer needs'
                },
                {
                    id: 2,
                    icon: 'fa fa-cube',
                    title: '3D modeling and rendering',
                    description: 'Create high-precision 3D models and realistic rendering effects to meet various visualization needs'
                },
                {
                    id: 3,
                    icon: 'fa fa-gears',
                    title: 'system integration',
                    description: 'Seamless integration of different systems to achieve data sharing and business process optimization'
                },
                {
                    id: 4,
                    icon: 'fa fa-line-chart',
                    title: 'Data Analysis and Visualization',
                    description: 'Transform complex data into intuitive visual charts to assist in decision analysis'
                },
                {
                    id: 5,
                    icon: 'fa fa-mobile',
                    title: 'mobile application development',
                    description: 'Develop cross platform mobile applications to provide excellent user experience'
                },
                {
                    id: 6,
                    icon: 'fa fa-eye',
                    title: 'VR/AR Solution',
                    description: 'Creating immersive experiences using virtual and augmented reality technology'
                }
            ],

            about_title: 'About Us',
            about_deputy_title: 'KingWin Digital is a high-tech enterprise specializing in software development and 3D modeling, with over 10 years of industry experience',
            about_h: 'Innovative technology, professional service',
            about_p1: 'our team is comprised of experienced software engineers and 3D modeling experts, dedicated to delivering' +
                'top-notch technical solutions to our clients. Whether it\'s a complex business system or an exquisite 3D' +
                'visualization, we can provide professional services.',
            about_p2: 'our clients are spread across multiple fields such as manufacturing, construction, healthcare, education' +
                'and training, and have successfully delivered hundreds of projects, earning high recognition from our' +
                'clients.',

            showcaseDetail_1: 'Project Name',
            showcaseDetail_2: 'Project Time',
            showcaseDetail_3: 'Project Category',
            showcaseDetail_4: 'Project Scale',
            showcaseDetail_5: 'Project Background',
            showcaseDetail_6: 'Cooperative Enterprise',
            showcaseDetail_7: 'Project Description',
            showcaseDetail_8: 'Project Content',
            showcaseDetail_9: 'Project Achievements',
            showcaseDetail_10: 'Customer Reviews',

        },
        zh: {
            contact_name: '姓名',
            contact_phone: '联系方式',
            contact_email: '邮箱',
            contact_service: '服务',
            contact_message: '留言',
            contact_cancel: '取消',
            contact_submit: '提交',
            contact_services: [{title: '软件开发',}, {title: '数据处理',}, {title: '3D建模',}],

            companyName: '精云科技',
            navItems: [
                {id: '/', title: '主页'},
                {id: '/services', title: '服务'},
                {id: '/showcase', title: '案例'},
                {id: '/about', title: '关于'},
            ],

            head_touch_button: '联系我们',
            head_language_button: '切换英文',

            foot_about: '精云科技是一家领先的技术解决方案提供商，致力于帮助客户实现业务通过创新技术实现转型和增长。',
            foot_title_about: '关于我们',
            foot_title_contact: '联系我们',
            foot_title_quick: '快速链接',
            foot_address: '江苏省苏州市苏州工业园区崇文路199号',

            hero_company: '精云数字科技有限公司',
            hero_description: '提供尖端数据服务、3D可视化技术和软件开发，促进企业数字化转型',
            hero_button: '了解更多',

            profile_title: '公司简介',
            profile_deputy_title: '了解我们专业且负责任的公司',
            profile_content_title: '创新科技，引领未来',
            profile_content_1: '精云科技成立于2019年，最初是一家小型初创公司，现已发展成为行业领先的技术解决方案提供商。我们的旅程始于一个简单的想法：通过技术让世界变得更美好。',
            profile_content_2: '多年来，我们与各行各业的客户合作，提供定制化的解决方案，帮助他们应对复杂的业务挑战，实现数字化转型。',
            profile_content_3: '我们的团队由经验丰富的工程师、设计师和行业专家组成，他们热衷于解决复杂问题并创造有影响力的解决方案。',

            team_title: '团队简介',
            team_deputy_title: '了解我们的专业和创意团队成员',
            teamMembers: [
                {
                    id: 1,
                    name: '张明',
                    position: '技术总监',
                    description: '15年软件开发经验，专注于企业级应用架构设计',
                    avatar: require('@/assets/teamMember_1.jpg')
                },
                {
                    id: 2,
                    name: '李学',
                    position: '设计总监',
                    description: '10年3D建模和可视化经验，擅长复杂场景建模',
                    avatar: require('@/assets/teamMember_2.jpg')
                },
                {
                    id: 3,
                    name: '王明',
                    position: '项目经理',
                    description: '12年项目管理经验，精通开发',
                    avatar: require('@/assets/teamMember_3.jpg')
                },
                {
                    id: 4,
                    name: '赵林',
                    position: '高级工程师',
                    description: '全栈开发专家，擅长集成前端和后端技术',
                    avatar: require('@/assets/teamMember_4.jpg')
                }
            ],

            data_title: '数据展示',
            data_deputy_title: '用数据说话，展示我们的专业能力和行业影响力',
            dataStats: [
                {
                    id: 1,
                    icon: 'fa fa-cubes',
                    value: '200+',
                    label: '成功交付项目'
                },
                {
                    id: 2,
                    icon: 'fa fa-industry',
                    value: '15+',
                    label: '服务领域'
                },
                {
                    id: 3,
                    icon: 'fa fa-line-chart',
                    value: '45%',
                    label: '年平均业务增长率'
                },
                {
                    id: 4,
                    icon: 'fa fa-smile-o',
                    value: '98%',
                    label: '客户满意度'
                },
                {
                    id: 5,
                    icon: 'fa fa-users',
                    value: '50+',
                    label: '专业团队成员'
                },
                {
                    id: 6,
                    icon: 'fa fa-globe',
                    value: '5',
                    label: '服务国家和地区'
                }
            ],


            service_title: '我们的服务',
            service_deputy_title: '我们的专业技术团队将为您提供全面的技术解决方案',
            services: [
                {
                    'id': 1,
                    'i': 'fa fa-code',
                    'h': '软件开发',
                    'p': '定制的软件开发服务，以满足企业的各种业务场景',
                    'li': [
                        'JAVA软件开发',
                        'Python开发',
                        'Agent开发，爬虫开发',
                        'APP开发，前端开发'
                    ]
                },
                {
                    'id': 2,
                    'i': 'fa fa-database',
                    'h': '数据服务',
                    'p': '提供从收集到分析的全面数据解决方案，帮助企业释放数据价值',
                    'li': [
                        '数据清洗、数据微调',
                        '数据整理',
                        '数据预训练',
                        '标注'
                    ]
                },
                {
                    'id': 3,
                    'i': 'fa fa-cube',
                    'h': '3D视觉技术',
                    'p': '专业的3D建模和渲染服务为您的产品提供逼真的视觉显示',
                    'li': [
                        '3D建模、 渲染、动画',
                        '特效、原画',
                        '卡通宣传页设计',
                        'logo设计，UI设计'
                    ]
                }
            ],

            reason_title: '选择理由',
            reason_deputy_title: '凭借先进的技术和丰富的经验，我们为客户提供卓越的解决方案',
            reason_h: '为什么选择精云科技',
            reason_p: '我们不仅提供技术解决方案，更重要的是，我们了解您的业务需求，可以将技术与业务目标相结合，创造真正的商业价值。',
            reason_expertiseList: [
                {id: 1, text: '拥有超过10年行业经验的技术团队'},
                {id: 2, text: '采用最新的开发工具和技术栈'},
                {id: 3, text: '严格的质量控制和测试流程'},
                {id: 4, text: '全面的售后支持和服务体系'},
                {id: 5, text: '灵活的交付模式和项目管理'},
                {id: 6, text: '保护客户知识产权和数据安全'}
            ],
            reason_stats: [
                {id: 1, number: 200, label: '成功项目'},
                {id: 2, number: 50, label: '工业客户'},
                {id: 3, number: 10, label: '多年经验'},
                {id: 4, number: 98, label: '客户满意度'}
            ],

            case_title: '成功案例',
            case_deputy_title: '探索我们为各行各业的客户提供的创新解决方案',
            cases: [
                {
                    id: 1,
                    title: '智能制造管理系统',
                    description: '为大型制造企业开发的智能生产管理系统实现了生产过程的数字化和自动化。',
                    image: require('@/assets/case_1.avif'),
                    tags: ['企业软件', '智能制造', 'ERP系统'],
                    category: '软件',
                    selectedCase: {
                        title: '智能制造工厂数字化转型项目',
                        description: '为大型制造企业打造智能化生产系统，实现生产流程的全面数字化和自动化管理。',
                        category: '智能制造',
                        date: '2023-03-15',
                        duration: '8个月',
                        scale: '大型项目',
                        background: '该制造企业面临生产效率低下、质量控制困难、设备利用率不高等问题。希望通过数字化转型实现生产过程的智能化管理，提高整体运营效率。',
                        solution: '我们提供了基于工业物联网和AI技术的智能制造解决方案，包括设备互联、生产数据实时采集与分析、智能排产、质量预测等功能模块。通过边缘计算和云计算结合的方式，实现了生产全流程的数字化管理。',
                        testimonial: '精云科技的解决方案帮助我们实现了生产过程的全面数字化，生产效率提升了35%，产品质量稳定性大幅提高。合作团队专业高效，项目交付超出预期。',
                        partners: [
                            {id: 1, name: '华为云（华为技术有限公司旗下研发和运营机构）', role: '云平台提供商'},
                            {id: 2, name: '西门子（中国）有限公司', role: '工业自动化合作伙伴'},
                            {id: 3, name: '中科曙光（曙光信息产业股份有限公司）', role: '硬件设备供应商'}
                        ],
                        video_url: require('@/assets/3d_2.mp4')
                    }
                },
                {
                    id: 2,
                    title: '三维可视化项目',
                    description: '为房地产开发商创建的高精度建筑模型和交互式可视化系统，以协助项目营销。',
                    image: require('@/assets/case_2.jpg'),
                    tags: ['3D建模', '可视化', 'VR/AR'],
                    category: '建模',
                    selectedCase: {
                        title: '智慧金融风控平台',
                        description: '为金融机构构建基于AI的智能风控系统，提升信贷审批效率和风险识别能力。',
                        category: '金融科技',
                        date: '2022-11-20',
                        duration: '6个月',
                        scale: '中型项目',
                        background: '金融机构在信贷审批过程中面临人工审核效率低、风险识别不准确等问题。需要构建智能风控系统来提高审批效率和准确性。',
                        solution: '我们开发了基于机器学习和深度学习的智能风控平台，整合了多源数据，构建了用户信用评分模型和欺诈检测模型。系统能够实时分析用户行为数据，自动识别潜在风险。',
                        testimonial: '智创科技的风控平台极大提升了我们的信贷审批效率，审批时间从原来的3天缩短到2小时，同时风险识别准确率提高了40%。',
                        partners: [
                            {id: 1, name: '腾讯云', role: '云计算服务商'},
                            {id: 2, name: '蚂蚁集团', role: '数据服务合作伙伴'},
                            {id: 3, name: '平安科技', role: '金融科技顾问'}
                        ],
                        video_url: require('@/assets/3d_1.mp4')
                    }
                },
                {
                    id: 3,
                    title: '大数据分析平台',
                    description: '为金融机构开发的实时数据分析和可视化平台，提供深入的业务见解。',
                    image: require('@/assets/case_3.avif'),
                    tags: ['数据分析', '数据清理'],
                    category: '软件',
                    selectedCase: {
                        title: '智慧医疗健康管理平台',
                        description: '为医疗机构打造智能健康管理平台，实现患者数据的互联互通和智能分析。',
                        category: '医疗健康',
                        date: '2023-01-10',
                        duration: '10个月',
                        scale: '大型项目',
                        background: '医疗机构面临患者数据分散、医疗资源分配不均、慢性病管理困难等问题。需要构建统一的健康管理平台来优化医疗服务流程。',
                        solution: '我们开发了基于云计算的智慧医疗平台，整合了电子病历、健康监测设备数据、医疗影像等多源信息。通过AI算法实现疾病预测、个性化治疗方案推荐等功能。',
                        testimonial: '该平台帮助我们实现了医疗数据的统一管理，医生工作效率提升了40%，患者满意度显著提高。特别是在慢性病管理方面取得了显著成效。',
                        partners: [
                            {id: 1, name: '阿里云', role: '云服务提供商'},
                            {id: 2, name: '华为', role: '医疗设备合作伙伴'},
                            {id: 3, name: '东软集团', role: '医疗信息化专家'}
                        ],
                        video_url: require('@/assets/3d_2.mp4')
                    }
                },
                {
                    id: 4,
                    title: '工业产品设计与仿真',
                    description: '为制造企业提供3D建模和物理仿真解决方案，优化产品设计过程。',
                    image: require('@/assets/case_4.avif'),
                    tags: ['产品设计', '物理模拟', '工业设计'],
                    category: '建模',
                    selectedCase: {
                        title: '智慧城市交通管理平台',
                        description: '为城市交通管理部门构建智能交通管理系统，优化交通流量和减少拥堵。',
                        category: '智慧城市',
                        date: '2022-08-05',
                        duration: '12个月',
                        scale: '大型项目',
                        background: '城市交通拥堵严重，交通管理效率低下，需要利用新技术优化交通流量分配和信号控制，提高道路利用效率。',
                        solution: '我们开发了基于物联网和大数据的智慧交通平台，通过部署智能传感器和摄像头，实时采集交通数据。利用AI算法进行交通流量预测和信号优化，实现智能交通调度。',
                        testimonial: '该交通管理平台显著改善了城市交通状况，高峰时段拥堵时间减少了30%，交通事故发生率下降了25%。为城市交通管理提供了有力支撑。',
                        partners: [
                            {id: 1, name: '百度', role: '地图数据服务商'},
                            {id: 2, name: '海康威视', role: '视频监控合作伙伴'},
                            {id: 3, name: '中国移动', role: '通信服务提供商'}
                        ],
                        video_url: require('@/assets/3d_1.mp4')
                    }
                },
                {
                    id: 5,
                    title: '医疗和健康移动应用程序',
                    description: '为医疗机构开发的移动健康管理平台，提供患者管理和远程医疗服务。',
                    image: require('@/assets/case_5.avif'),
                    tags: ['移动应用程序', 'iOS/Android'],
                    category: '软件',
                    selectedCase: {
                        title: '新零售智能供应链系统',
                        description: '为零售企业构建智能供应链管理系统，实现库存优化和精准需求预测。',
                        category: '零售电商',
                        date: '2023-05-20',
                        duration: '7个月',
                        scale: '中型项目',
                        background: '零售企业面临库存积压、缺货频发、供应链响应慢等问题。需要通过智能化手段优化供应链管理，提高运营效率。',
                        solution: '我们开发了基于AI的智能供应链系统，整合销售数据、库存数据、供应商信息等，通过机器学习算法实现精准需求预测和智能补货。系统还提供了供应商协同平台，优化了整个供应链的协同效率。',
                        testimonial: '智能供应链系统帮助我们实现了库存周转率提升50%，缺货率降低60%，显著提高了客户满意度和企业盈利能力。',
                        partners: [
                            {id: 1, name: '京东云', role: '云服务与物流合作伙伴'},
                            {id: 2, name: '顺丰科技', role: '物流技术提供商'},
                            {id: 3, name: '用友网络', role: 'ERP系统集成商'}
                        ],
                        video_url: require('@/assets/3d_2.mp4')
                    }
                },
                {
                    id: 6,
                    title: '虚拟现实训练系统',
                    description: '为能源公司开发的VR安全培训系统，提供身临其境的操作培训体验。',
                    image: require('@/assets/case_6.avif'),
                    tags: ['VR/AR', '训练系统', '三维交互'],
                    category: '建模',
                    selectedCase: {
                        title: '区块链供应链金融平台',
                        description: '为金融机构和供应链企业构建基于区块链的供应链金融平台，提高融资效率和透明度。',
                        category: '金融科技',
                        date: '2022-12-15',
                        duration: '9个月',
                        scale: '中型项目',
                        background: '传统供应链金融存在信息不透明、融资流程复杂、风险控制困难等问题。需要利用区块链技术提高供应链金融的透明度和效率。',
                        solution: '我们开发了基于区块链的供应链金融平台，通过分布式账本技术实现交易数据的不可篡改和透明可追溯。平台提供了智能合约功能，自动化执行融资流程，大大提高了融资效率。',
                        testimonial: '区块链供应链金融平台显著提升了我们的业务处理效率，融资审批时间从原来的5天缩短到1天，同时降低了操作风险和欺诈风险。',
                        partners: [
                            {id: 1, name: '蚂蚁链', role: '区块链技术提供商'},
                            {id: 2, name: '微众银行', role: '金融机构合作伙伴'},
                            {id: 3, name: '联想', role: '供应链企业'}
                        ],
                        video_url: require('@/assets/3d_1.mp4')
                    }
                }
            ],

            expertise_title: '技术优势',
            expertise_deputy_title: '凭借先进的技术和丰富的经验，我们为客户提供卓越的解决方案',
            expertises: [
                {
                    id: 1,
                    icon: 'fa fa-code',
                    title: '定制化软件开发',
                    description: '根据客户需求开发功能齐全、性能卓越的定制软件解决方案'
                },
                {
                    id: 2,
                    icon: 'fa fa-cube',
                    title: '3D建模和渲染',
                    description: '创建高精度3D模型和逼真的渲染效果，以满足各种可视化需求'
                },
                {
                    id: 3,
                    icon: 'fa fa-gears',
                    title: '系统集成',
                    description: '无缝集成不同系统，实现数据共享和业务流程优化'
                },
                {
                    id: 4,
                    icon: 'fa fa-line-chart',
                    title: '数据分析和可视化',
                    description: '将复杂数据转换为直观的可视化图表，以协助决策分析'
                },
                {
                    id: 5,
                    icon: 'fa fa-mobile',
                    title: '移动应用开发',
                    description: '开发跨平台移动应用程序，提供卓越的用户体验'
                },
                {
                    id: 6,
                    icon: 'fa fa-eye',
                    title: 'VR/AR解决方案',
                    description: '使用虚拟和增强现实技术创建沉浸式体验'
                }
            ],

            about_title: '关于我们',
            about_deputy_title: '我们是一家专业从事软件开发和3D建模以及企业数据处理的高科技企业，拥有10多年的行业经验',
            about_h: '创新技术，专业服务',
            about_p1: '我们的团队由经验丰富的软件工程师和3D建模专家组成，致力于为客户提供一流的技术解决方案。无论是复杂的业务系统还是精致的3D可视化，我们都能提供专业服务。',
            about_p2: '我们的客户遍布制造业、建筑业、医疗保健、教育和培训等多个领域，并成功交付了数百个项目，赢得了客户的高度认可。',

            showcaseDetail_1: '项目名称',
            showcaseDetail_2: '项目时间',
            showcaseDetail_3: '项目类别',
            showcaseDetail_4: '项目规模',
            showcaseDetail_5: '项目背景',
            showcaseDetail_6: '合作企业',
            showcaseDetail_7: '项目描述',
            showcaseDetail_8: '项目内容',
            showcaseDetail_9: '项目成果',
            showcaseDetail_10: '客户评价',

        }
    }
})

new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')
